import React from "react";
import { Box, Typography, Divider, IconButton } from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

function formatBytes(bytes) {
    if (!Number.isFinite(bytes)) return "";
    const units = ["B", "KB", "MB", "GB"];
    let i = 0;
    let n = bytes;
    while (n >= 1024 && i < units.length - 1) {
        n /= 1024;
        i++;
    }
    return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

function FileRow({ label, file, onRemove }) {
    return (
        <Box sx={{ mb: 1.5 }}>
            <Typography variant="body2" sx={{ opacity: 0.75, mb: 0.5 }}>
                {label}
            </Typography>

            {!file ? (
                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                    No file selected
                </Typography>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "360px",
                            }}
                            variant="body2"
                            title={file.name}
                        >
                            {file.name}
                        </Typography>

                        <Typography variant="body2" sx={{opacity: 0.6 }}>
                            {formatBytes(file.size)}
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={onRemove}
                        size="small"
                        sx={{
                            color: "rgba(255,255,255,.6)",
                            "&:hover": { color: "#ff4d4f" },
                        }}
                        aria-label={`Remove ${label}`}
                    >
                        <DeleteOutlineRoundedIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}

            <Divider sx={{ borderColor: "rgba(255,255,255,.2)", mt: 1 }} />
        </Box>
    );
}

export default function UploadedThreeFilesDisplay({
    metaData,
    r1File,
    r2File,
    onRemoveVariable1 = () => { },
    onRemoveR1 = () => { },
    onRemoveR2 = () => { },
    title = "Uploaded files",
    labels = ["Metadata", "FASTQ R1", "FASTQ R2"],
    inactive = false
}) {
    return (
        <Box sx={{ mb: 4 }}>
            <Box sx={{ height: '60px' }}>
                <Typography variant="body1" sx={{ mt: 3 }}>
                    {title}
                </Typography>
            </Box>

            <FileRow label={labels[0]} file={metaData} onRemove={onRemoveVariable1} />
            <FileRow label={labels[1]} file={r1File} onRemove={onRemoveR1} />
            {inactive === false && <FileRow label={labels[2]} file={r2File} onRemove={onRemoveR2} />}
        </Box>
    );
}
